import './skeleton.scss'

const Skeleton: React.FC = () => {
   return (
      <>
         <div className="loading__block">
            <img height={187} width={150} src="img/loadingBlock.jpg" alt="" />
         </div>
         <div className="loading__block">
            <img height={187} width={150} src="img/loadingBlock.jpg" alt="" />
         </div>
         <div className="loading__block">
            <img height={187} width={150} src="img/loadingBlock.jpg" alt="" />
         </div>
         <div className="loading__block">
            <img height={187} width={150} src="img/loadingBlock.jpg" alt="" />
         </div>
         <div className="loading__block">
            <img height={187} width={150} src="img/loadingBlock.jpg" alt="" />
         </div>
         <div className="loading__block">
            <img height={187} width={150} src="img/loadingBlock.jpg" alt="" />
         </div>
         <div className="loading__block">
            <img height={187} width={150} src="img/loadingBlock.jpg" alt="" />
         </div>
         <div className="loading__block">
            <img height={187} width={150} src="img/loadingBlock.jpg" alt="" />
         </div>
      </>

   )
}

export default Skeleton;
